import React from "react";

/**
 * Repeating brand-colour stripe. Matches the footer stripe used on
 * every page of the Good Eyes Brand Book V2.
 */
export const BrandStripe = ({ className = "", height = 22 }) => (
  <div
    className={`brand-stripe ${className}`}
    style={{ height }}
    aria-hidden="true"
  >
    <span style={{ background: "var(--ge-beige)" }} />
    <span style={{ background: "var(--ge-yellow)" }} />
    <span style={{ background: "var(--ge-red)" }} />
    <span style={{ background: "var(--ge-green)" }} />
    <span style={{ background: "var(--ge-navy)" }} />
  </div>
);

export default BrandStripe;
